import { IRequestCommand } from 'app/services/authentication/connection/iRequestCommand';
import { ErrorDetails } from 'app/services/authentication/connection/interfaces/apiInterfaces';
import { ICommandParameters } from 'app/services/authentication/connection/iCommandParameters';
import { ICommandResponse } from 'app/services/authentication/connection/iCommandResponse';
import { CommandRequestType } from 'app/services/authentication/connection/commandRequestType';

export class GetPassengerByAreaCommand extends IRequestCommand<IGetPassengerByAreaResponse,
  ErrorDetails,
  IGetPassengerByAreaCommandParameters> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'contractorEmployees/byArea/{areaId}/paginated';
  override _needAuthenticate = true;

  public override setParameters(parameters: IGetPassengerByAreaCommandParameters) {
    this._commandUrl = this._commandUrl.replace('{areaId}', parameters.areaId.toString());
  }
}

export interface IGetPassengerByAreaCommandParameters extends ICommandParameters {
  areaId: string;
}

export interface IGetPassengerByAreaResponse extends ICommandResponse {
  content: Array<{ id: number; name: string; lastName: string }>;
}
